import { connect } from 'react-redux';
import QRLogin from './QRLogin';

const mapStateToProps = ({ branding, _t }) => ({
  branding: branding,
  _t: _t,
});

export default connect(mapStateToProps, null)(QRLogin);
